import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  accommodationMissionOrder(accommodationId, filter) {
    return Api()
      .get(`/mission-orders/accommodation/${accommodationId}`, {params: removeEmptyParams(filter)})
      .then((res) => this.formatRes(res.data));
  },
  create(missionOrders) {
    return Api()
      .post('/mission-orders', missionOrders)
      .then((res) => {
        return res.data;
      });
  },
  formatRes(e) {
    return e;
  },
};
